// extracted by mini-css-extract-plugin
export default {"input":"TagsInput_input__3FAC2","tag":"TagsInput_tag__2C4vn","tags":"TagsInput_tags__FP-92"};